import { render, staticRenderFns } from "./DatosCliente.vue?vue&type=template&id=96d1adda"
import script from "./DatosCliente.vue?vue&type=script&lang=js"
export * from "./DatosCliente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports